module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./DownloadVideoTipView.js"));
	}, "DownloadVideoTipView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=DownloadVideoTipView!./src/pages/Learn/Download/DownloadVideoTipView.js
// module id = 1265
// module chunks = 431